// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 状态管理(推荐！)
import store from './store'
Vue.config.productionTip = false
//引入样式
import './assets/reset.css'
//使用swiper
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style
// import 'swiper/css/swiper.min.css'
// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
// 全局引入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//获取api列表
import Apis from './apis/control'
Vue.prototype.$Apis = Apis;
 
Vue.use(ElementUI)
//自定义组件
import initCgComponents from './components/index'
Vue.use(initCgComponents)

//数据处理
import * as filters from './util/filters';
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js